import React from 'react';
import { withTranslation } from 'react-i18next';
import { map } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Body, Headline, Toggle } from '@sumup/circuit-ui';

import { useAuth } from '../../../context/auth';

const Permissions = ({ t, preferences, setPreferences }) => {
  const {
    sessionData: { tppName, account },
  } = useAuth();
  const { accountInfo, balanceTxHistory } = preferences;

  const accessToggles = (translate) => [
    {
      label: translate('accounts.account_information'),
      method: () => {
        setPreferences({
          ...preferences,
          accountInfo: !accountInfo,
        });
      },
      isChecked: accountInfo,
      id: 'account-info',
    },
    {
      label: translate('accounts.balance_transaction_history'),
      method: () => {
        setPreferences({
          ...preferences,
          balanceTxHistory: !balanceTxHistory,
        });
      },
      isChecked: balanceTxHistory,
      id: 'balance-transaction-history',
    },
  ];

  return (
    <>
      <Headline as="h1" size="three">
        {t('accounts.enable_settings')}
      </Headline>
      <Body
        style={{
          paddingTop: 'var(--cui-spacings-mega)',
          paddingBottom: 'var(--cui-spacings-mega)',
        }}
      >
        {t('accounts.permissions_prompt', {
          providerName: tppName,
          sumup_account: account.accountName,
          interpolation: { escapeValue: false },
        })}
      </Body>
      <Body
        variant="highlight"
        style={{ paddingBottom: 'var(--cui-spacings-byte)' }}
      >
        {t('accounts.access_heading')}
      </Body>
      <Body style={{ paddingBottom: 'var(--cui-spacings-kilo)' }}>
        {map(
          ({ label, method, isChecked, id }) => (
            <Toggle
              checked={isChecked}
              checkedLabel="on"
              uncheckedLabel="off"
              onChange={() => {
                method(!isChecked);
              }}
              label={label}
              style={{ paddingBottom: 'var(--cui-spacings-byte)' }}
              key={id}
            />
          ),
          accessToggles(t),
        )}
      </Body>
    </>
  );
};

Permissions.propTypes = {
  t: PropTypes.func.isRequired,
  preferences: PropTypes.shape({
    accountInfo: PropTypes.bool.isRequired,
    balanceTxHistory: PropTypes.bool.isRequired,
  }).isRequired,
  setPreferences: PropTypes.func.isRequired,
};

export default withTranslation()(Permissions);
